import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'

import {
  loadInDemand,
  loadTopQcewEmployment,
  loadTopQcewWage,
  rateIndustry,
  updateFilter
} from '../../actions/industry'

const ChoosingIndustryList = ({ listing, filter, onChange, loading, onFilter }) => {
  return (
    <div className="container">
      <div className="filter">
        <fieldset>
          <div className="item form-group">
            <label htmlFor="number_to_display">{t`Number to Display `}</label>
            <div className="description"></div>
            <div className="itemValContainer">
              <div className="itemValue">
                <select
                  className="form-control"
                  id="number_to_display"
                  value={new String(filter.numToDisplay)}
                  onChange={v => onChange('numToDisplay', parseInt(v.target.value))}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
          {filter.additional.map(a => {
            return (
              <div className="item form-group" key={a.id}>
                <label htmlFor={a.id}>{a.name}</label>
                <div className="description"></div>
                <div className="itemValContainer">
                  <div className="itemValue">
                    <select
                      className="form-control"
                      id={a.id}
                      value={new String(filter[a.id] || '')}
                      onChange={v => onChange(a.id, v.target.value)}>
                      <option value="">{t`All Sectors`}</option>
                      {a.items.map(i => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )
          })}
          <div className="nav" style={{ marginTop: '1em' }}>
            <button
              type="button"
              className="btn btn-gray"
              onClick={() => onFilter(filter)}>
              {t`Filter`}{' '}
              <i
                className="fal fa-circle-notch fa-spin"
                style={{ display: loading ? 'inline-block' : 'none' }}>
              </i>
            </button>
          </div>
        </fieldset>
      </div>
      <table className="table tbl">
        <thead>
          <tr>
            <th>{t`Industry`}</th>
            <th>{t`Employment Openings`}</th>
            <th>{t`Annual Wage`}</th>
          </tr>
        </thead>
        <tbody>
          {listing.map((l, idx) => (
            <tr key={l.url} className={idx % 2 == 0 ? 'even' : 'odd'}>
              <td>
                <a href={l.url}>{l.name}</a>
              </td>
              <td>{l.employment.toLocaleString()}</td>
              <td>
                {l.annualWage
                  .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                  .slice(0, -3)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.industry.choosing
    }
  },
  dispatch => ({
    rateIndustry: (occupation, rating) => dispatch(rateIndustry(occupation, rating)),
    onFilter: filter => {
      console.log(filter)

      switch (filter.type) {
        case 3:
          return dispatch(loadInDemand())
        case 2:
          return dispatch(loadTopQcewWage())
        default:
          return dispatch(loadTopQcewEmployment())
      }
    },
    onChange: (k, v) => dispatch(updateFilter(k, v))
  })
)(ChoosingIndustryList)
